export enum PainArea {
    LeftShoulder = "Left Shoulder",
    RightShoulder = "Right Shoulder",
    Chest = "Chest",
    LeftElbow = "Left Elbow",
    RightElbow = "Right Elbow",
    LeftArm = "Left Arm",
    RightArm = "Right Arm",
    LeftWrist = "Left Wrist",
    RightWrist = "Right Wrist",
    LeftHip = "Left Hip",
    RightHip = "Right Hip",
    LeftThigh = "Left Thigh",
    RightThigh = "Right Thigh",
    LeftKnee = "Left Knee",
    RightKnee = "Right Knee",
    LeftAnkle = "Left Ankle",
    RightAnkle = "Right Ankle",
    Neck = "Neck",
    UpperBack = "Upper Back",
    LowerBack = "Lower Back",
    SiJoint = "Si-Joint",
    LeftHamstring = "Left Hamstring",
    RightHamstring = "Right Hamstring",
    LeftCalf = "Left Calf",
    RightCalf = "Right Calf",
    LeftAchilles = "Left Achilles",
    RightAchilles = "Right Achilles",
    LeftGlute = "Left Glute",
    RightGlute = "Right Glute",
}

export const PainAreaToTranslationKey: Record<PainArea, string> = {
    [PainArea.LeftShoulder]: "api.questions.pain.leftShoulder",
    [PainArea.RightShoulder]: "api.questions.pain.rightShoulder",
    [PainArea.Chest]: "api.questions.pain.chest",
    [PainArea.LeftElbow]: "api.questions.pain.leftElbow",
    [PainArea.RightElbow]: "api.questions.pain.rightElbow",
    [PainArea.LeftArm]: "api.questions.pain.leftArm",
    [PainArea.RightArm]: "api.questions.pain.rightArm",
    [PainArea.LeftWrist]: "api.questions.pain.leftWrist",
    [PainArea.RightWrist]: "api.questions.pain.rightWrist",
    [PainArea.LeftHip]: "api.questions.pain.leftHip",
    [PainArea.RightHip]: "api.questions.pain.rightHip",
    [PainArea.LeftThigh]: "api.questions.pain.leftThigh",
    [PainArea.RightThigh]: "api.questions.pain.rightThigh",
    [PainArea.LeftKnee]: "api.questions.pain.leftKnee",
    [PainArea.RightKnee]: "api.questions.pain.rightKnee",
    [PainArea.LeftAnkle]: "api.questions.pain.leftAnkle",
    [PainArea.RightAnkle]: "api.questions.pain.rightAnkle",
    [PainArea.Neck]: "api.questions.pain.neck",
    [PainArea.UpperBack]: "api.questions.pain.upperBack",
    [PainArea.LowerBack]: "api.questions.pain.lowerBack",
    [PainArea.SiJoint]: "api.questions.pain.siJoint",
    [PainArea.LeftHamstring]: "api.questions.pain.leftHamstring",
    [PainArea.RightHamstring]: "api.questions.pain.rightHamstring",
    [PainArea.LeftCalf]: "api.questions.pain.leftCalf",
    [PainArea.RightCalf]: "api.questions.pain.rightCalf",
    [PainArea.LeftAchilles]: "api.questions.pain.leftAchilles",
    [PainArea.RightAchilles]: "api.questions.pain.rightAchilles",
    [PainArea.LeftGlute]: "api.questions.pain.leftGlute",
    [PainArea.RightGlute]: "api.questions.pain.rightGlute",
};

